/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Button, Select, InputFormGroup, Card, Row, Column, colors, DatePicker } from '@bonitour/components'
import { BraspagScheduleFilterSchema } from './BraspagScheduleFilter.schema'
import { useForm } from '@bonitour/app-functions'
import { BRAND_OPTIONS } from 'Shared/constants/brandOptions'

const stylishCardSearch = css`
  border: none;
  background-color: ${colors.gray8};
  padding: 1.25rem;
  margin-bottom: 1.25rem;
`
const button = css`
  height: 2.5rem;
  width: 100%;
  margin-top: auto;
`

const width100 = css`
  width: 100%;
`

const BASE_FORM = {}

export const BraspagScheduleFilter = ({
  handleFiltersChange,
  filters = undefined,
  loadingBraspagSchedule
}) => {
  const {
    form,
    errors,
    onSubmit,
    utils: {
      onInputChange,
      onInputBlur
    }
  } = useForm(filters || BASE_FORM, BraspagScheduleFilterSchema)

  const { initialDate, finalDate, brand } = form

  return (
    <Card css={stylishCardSearch}>
      <Row>
        <Column phone={12} desktop={3}>
          <InputFormGroup label='Data inicial' errorMessage={errors.initialDate}>
            <DatePicker
              id='initialDate'
              css={width100}
              value={initialDate}
              placeholder='Data Inicial'
              onChange={onInputChange('initialDate')}
              onBlur={onInputBlur('initialDate')}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} desktop={3}>
          <InputFormGroup label='Data final' errorMessage={errors.finalDate}>
            <DatePicker
              id='finalDate'
              css={width100}
              value={finalDate}
              placeholder='Data Final'
              onChange={onInputChange('finalDate')}
              onBlur={onInputBlur('finalDate')}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} desktop={3}>
          <InputFormGroup label='Bandeira'>
            <Select
              id='brand'
              value={brand}
              onChange={onInputChange('brand')}
              placeholder='Selecione uma bandeira'
              options={BRAND_OPTIONS || []}
            />
          </InputFormGroup>
        </Column>
        <Column phone={12} desktop={3}>
          <Button
            css={button}
            onClick={onSubmit(handleFiltersChange)}
            disabled={loadingBraspagSchedule}
          >
            Pesquisar
          </Button>
        </Column>
      </Row>
    </Card>
  )
}
